// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import BaiduMap from 'vue-baidu-map';
import * as echarts from 'echarts';
import axios from 'axios'
import api from './api/index';
import qs from 'qs'

import JsonExcel from 'vue-json-excel'
import htmlToPdf from '../src/utils/htmlToPdf'
import VueCookies from 'vue-cookies'
import cookies from 'vue-cookies'
import "./assets/icon/iconfont.css"


import china from './api/china.json'
echarts.registerMap('china', china)

// 引用全局样式
import './assets/css/global.css'
Vue.prototype.$cookies = cookies; 
Vue.use(VueCookies)
Vue.use(htmlToPdf)
Vue.component('downloadExcel', JsonExcel)
Vue.prototype.$qs = qs
Vue.prototype.$api = api 
Vue.prototype.$http = axios
Vue.prototype.$echarts = echarts
axios.defaults.baseURL = '/proxy_url'
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: 'RF9LwfobCt0WiLS1XU7cgs93YM01PybM'
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js